/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Chip, Tooltip } from '@mui/material'
import { ScenarioCell, SEDIMENT_COLORS } from '../utils/hazardScenarioGrid.utils'
import { scenarioPillStyles } from './HazardScenarioGrid.styles'

type HazardScenarioPillProps = {
  cell: ScenarioCell
  isSelected: boolean
  onSelect: (assetTag: string) => void
}

const dotPillStyles = (color: string, isSelected: boolean) => css`
  background-color: ${isSelected ? color : `${color}99`} !important;
  color: transparent !important;
  min-width: 24px;
  width: 24px;
  height: 24px;
  border-radius: 50% !important;
  border: 2px solid ${isSelected ? color : `${color}cc`};
  transition:
    background-color 0.15s,
    transform 0.15s;
  transform: ${isSelected ? 'scale(1.2)' : 'scale(1)'};

  .MuiChip-label {
    display: none;
  }

  &:hover {
    background-color: ${color} !important;
    transform: scale(1.15);
  }
`

export const HazardScenarioPill = ({ cell, isSelected, onSelect }: HazardScenarioPillProps) => {
  if (!cell.hasSediment && cell.dotColor) {
    return (
      <Tooltip title={cell.scenario.display_name} placement="top" arrow>
        <Chip
          label="●"
          size="small"
          onClick={() => onSelect(cell.assetTag)}
          css={dotPillStyles(cell.dotColor, isSelected)}
          clickable
          aria-pressed={isSelected}
          aria-label={`${cell.scenario.display_name}${isSelected ? ', selected' : ''}`}
        />
      </Tooltip>
    )
  }

  const colors = SEDIMENT_COLORS[cell.sedimentLabel] ?? SEDIMENT_COLORS.NC

  return (
    <Tooltip title={cell.scenario.display_name} placement="top" arrow>
      <Chip
        label={cell.sedimentLabel}
        size="small"
        onClick={() => onSelect(cell.assetTag)}
        css={scenarioPillStyles(isSelected, colors)}
        clickable
        aria-pressed={isSelected}
        aria-label={`${cell.scenario.display_name}${isSelected ? ', selected' : ''}`}
      />
    </Tooltip>
  )
}
